import { css } from '@emotion/react';
import { NString } from '@mobalytics/shared';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { AllowedActionsT } from '../../payment.types';
import { paymentFormHeaderCss } from '../payment-details.styles';
import { StripeNewFlow } from '../payment-flow/stripe-flow/stripe-new-flow/stripe-new-flow.component';
import { usePaypalFlowNew } from '../payment-flow/paypal-flow/paypal-flow-new/paypal-flow-new.hook';
import { PaypalAuthButton } from '../payment-flow/paypal-flow/paypal-auth-button.component';
import { PaypalConfirmation } from '../payment-flow/paypal-flow/paypal-confirmation.component';

interface Props {
  className?: string;
  planId: NString;
  productAbbreviation: string;
  coupon: NString;
  allowedActions: AllowedActionsT;
  shouldPrepareBillingInfoFirst: boolean;
  submitButtonLabel: string;
}

export const PaymentMethods: React.FC<Props> = (props) => {
  const {
    className,
    planId,
    productAbbreviation,
    coupon,
    allowedActions,
    shouldPrepareBillingInfoFirst,
    submitButtonLabel,
  } = props;
  const { t } = useTranslation();
  const { loading, step, tokenResponse, processPayment, onPaypalApprove } = usePaypalFlowNew({
    planId,
    productAbbreviation,
    coupon,
    allowedActions,
  });

  if (step === 'billing-info' && tokenResponse) {
    return (
      <PaypalConfirmation
        className={className}
        loading={loading}
        buttonLabel={submitButtonLabel}
        onSubmit={processPayment}
        tokenResponse={tokenResponse}
      />
    );
  }

  return (
    <div className={className}>
      <p css={paymentFormHeaderCss}>{t('Enter payment details')}</p>
      <StripeNewFlow
        allowedActions={allowedActions}
        planId={planId ?? ''}
        coupon={coupon}
        productAbbreviation={productAbbreviation}
        shouldPrepareBillingInfoFirst={shouldPrepareBillingInfoFirst}
        submitButtonLabel={submitButtonLabel}
        paypalButton={<PaypalAuthButton css={paypalCss} onApprove={onPaypalApprove} />}
      />
    </div>
  );
};

const paypalCss = css`
  margin-top: 8px;
`;
